module.exports = __webpack_public_path__ + "img/header.57ff9c8c.jpg";